import {PIXI} from '@colonist/pixi'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGameActionButtonMultiView} from '../ui_game_actions/UIGameActionButtonMultiView'
import {UIGameActionButtonViewCityImprovement} from '../ui_game_actions/UIGameActionButtonViewCityImprovement'
import {UIGameMapMetropolisController} from '../ui_game_map/UIGameMapMetropolisController'
import {UIGamePlayerInformationCityImprovementProgressTrackerView} from './UIGamePlayerInformationCityImprovementProgressTrackerView'
import {UIGameCityImprovementAchievementController} from './UIGameCityImprovementAchievementController'
import {UIGameMetropolisAchievementController} from './UIGameMetropolisAchievementController'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {CityImprovementTypes, MechanicCityImprovementsState, MechanicRobberState} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {MechanicValidatorCityImprovements} from '@colonist/game-mechanic-validators'

export abstract class UIGameCityImprovement implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    protected multiButton: UIGameActionButtonMultiView

    protected readonly cityImprovementsState: MechanicCityImprovementsState
    protected readonly cityImprovementsValidator: MechanicValidatorCityImprovements

    constructor(uiGameManager: UIGameManager, cityImprovementsState: MechanicCityImprovementsState, robberState: MechanicRobberState | undefined) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.cityImprovementsState = cityImprovementsState
        this.cityImprovementsValidator = new MechanicValidatorCityImprovements(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.cityImprovementsState)

        new UIGameMapMetropolisController(this.uiGameManager, robberState)
        new UIGameMetropolisAchievementController(this.uiGameManager, this.cityImprovementsValidator)
        new UIGameCityImprovementAchievementController(this.uiGameManager, this.cityImprovementsValidator.getPlayerCityImprovementsState(this.uiGameManager.gameController.myColor))
        this.createCityImprovementProgressTrackerController()
        this.initCityImprovementButton()
    }

    protected abstract createCityImprovementProgressTrackerController()

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.ForceShowCityImprovementButtons: this.multiButton.forceShowButtons(); break
            default: break
        }
    }

    protected abstract createButtonMultiView(buttonContainer: PIXI.Container)

    protected initCityImprovementButton() {
        if(this.uiGameManager.gameController.isPlayerSpectator) return
        if(this.uiGameManager.gameController.isReplay) return

        const buttonContainer = this.uiGameManager.actionsController.container
        this.createButtonMultiView(buttonContainer)
        if(!UIUtilsEjsVariables.isUserOnMobileApp) this.multiButton.setTip({key: 'strings:game.tooltips.cityImprovements'}, [{key: 'strings:colonistCommon.utils.emptyString'}])

        const myCityImprovementState = this.cityImprovementsValidator.getPlayerCityImprovementsState(this.uiGameManager.gameController.myColor)
        if(myCityImprovementState == undefined) return

        const progressTrackerW = this.multiButton.viewContainer.absoluteWidth * 0.4
        const progressTrackerH = this.multiButton.viewContainer.absoluteHeight * 0.2
        const progressTrackerY = this.multiButton.viewContainer.absoluteHeight * 0.05
        const myCityProgressTrackerView = new UIGamePlayerInformationCityImprovementProgressTrackerView(this.uiGameManager, this.cityImprovementsState, this.uiGameManager.gameController.myColor, 0, progressTrackerY, progressTrackerW, progressTrackerH, this.multiButton)
        this.multiButton.addAsset(myCityProgressTrackerView)
        this.multiButton.centerIconInX(myCityProgressTrackerView)
        this.uiGameManager.actionsController.addButton(this.multiButton)

        for(const cityImprovement of Object.keys(myCityImprovementState)) {
            const cityImprovementType = parseInt(cityImprovement, 10) as CityImprovementTypes
            const newCityImprovementButton = new UIGameActionButtonViewCityImprovement(this.uiGameManager, buttonContainer, cityImprovementType, this.multiButton, this.cityImprovementsValidator)
            this.multiButton.addButton(newCityImprovementButton)
        }
    }
}
